// import Statistics from './Statistics.js';
import {  Statistics } from './Statistics.js'
export default Statistics
